import type {ComponentType,SVGProps} from "react";
import BarChart from "./openai-icons/BarChart";
import Bell from "./openai-icons/Bell";
import Branch from "./openai-icons/Branch";
import Business from "./openai-icons/Business";
import Calendar from "./openai-icons/Calendar";
import Chat from "./openai-icons/Chat";
import CloseBold from "./openai-icons/CloseBold";
import Code from "./openai-icons/Code";
import Cube from "./openai-icons/Cube";
import Document from "./openai-icons/Document";
import Groups from "./openai-icons/Groups";
import Home from "./openai-icons/Home";
import Invoice from "./openai-icons/Invoice";
import Members from "./openai-icons/Members";
import Menu from "./openai-icons/Menu";
import Plus from "./openai-icons/Plus";
import Search from "./openai-icons/Search";
import SettingsCog from "./openai-icons/SettingsCog";
import ShieldCheck from "./openai-icons/ShieldCheck";
import ShieldPerson from "./openai-icons/ShieldPerson";
import ShoppingBag from "./openai-icons/ShoppingBag";
import Stack from "./openai-icons/Stack";
import UserHeart from "./openai-icons/UserHeart";
export type FlusiaGlyph='menu'|'close'|'plus'|'search'|'chat'|'bell'|'flu'|'people'|'roles'|'team'|'contacts'|'pipeline'|'chart'|'calendar'|'market'|'shield'|'settings'|'offer'|'box'|'code'|'automation'|'document'|'home'|'gift';

/** OpenAI Apps SDK UI icons; provenance and MIT license in openai-icons/. */
const icons:Record<Exclude<FlusiaGlyph,"flu">,ComponentType<SVGProps<SVGSVGElement>>>={
 menu:Menu,
 close:CloseBold,
 plus:Plus,
 search:Search,
 chat:Chat,
 bell:Bell,
 people:Members,
 roles:ShieldPerson,
 team:Groups,
 contacts:Business,
 pipeline:Stack,
 chart:BarChart,
 calendar:Calendar,
 market:ShoppingBag,
 shield:ShieldCheck,
 settings:SettingsCog,
 offer:Invoice,
 box:Cube,
 code:Code,
 automation:Branch,
 document:Document,
 home:Home,
 gift:UserHeart
};
export function flusiaGlyph(value:string):FlusiaGlyph{
 const v=value.toLowerCase();
 if(/pipeline|kanban|columns/.test(v))return 'pipeline';
 if(/role|permission/.test(v))return 'roles';
 if(/department|repart|team-planning/.test(v))return 'team';
 if(/referral|segnalator/.test(v))return 'gift';
 if(/user|people|team|consultant/.test(v))return 'people';
 if(/client|contact|lead/.test(v))return 'contacts';
 if(/report|chart|dashboard|analytic|target/.test(v))return 'chart';
 if(/calendar|booking|task|event/.test(v))return 'calendar';
 if(/market|integrat|plugin/.test(v))return 'market';
 if(/security|shield|lock/.test(v))return 'shield';
 if(/notification|bell/.test(v))return 'bell';
 if(/chat|message|whatsapp|mail|newsletter/.test(v))return 'chat';
 if(/deal|offer|preventiv|invoice|subscription|credit/.test(v))return 'offer';
 if(/warehouse|magazz|product|box|service/.test(v))return 'box';
 if(/api|code|develop/.test(v))return 'code';
 if(/automat|workflow/.test(v))return 'automation';
 if(/document|file|form|wiki|import|export/.test(v))return 'document';
 if(/home/.test(v))return 'home';
 return 'settings';
}

export function FlusiaIcon({name,size=22,...props}:SVGProps<SVGSVGElement>&{name:FlusiaGlyph;size?:number}){
 if(name==='flu')return <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true" focusable="false" data-flusia-glyph={name} {...props}><path d="M3 2h19v1a5 5 0 0 1-5 5H8v5h9v1a4 4 0 0 1-4 4H8v5H3V2Z"/></svg>;
 const Icon=icons[name];
 return <Icon width={size} height={size} aria-hidden="true" focusable="false" data-flusia-glyph={name} data-icon-source="openai-apps-sdk-ui" {...props}/>;
}
